import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { Getrequestcall } from "../../request/Getrequest";
import { DEACTIVATE_USER_ACCOUNT } from "../../constant/Apipath";
import { persistor } from "../../redux/store/store";
import { English } from "../../constant/EnglishFallback";
import Pageheader from "../common/Pageheader";
import Loader from "../../common/Loader";

export default function CloseAccount() {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [checkboxState, setCheckboxState] = useState({ firstBox: false, secondBox: false });
  const [isLoading, setIsLoading] = useState(false);
  const {
    TEXT_CLOSE_ACCOUNT = English?.CloseAccount?.TEXT_CLOSE_ACCOUNT,
    TEXT_ABOUT_TO_DELETE_ACCOUNT = English?.CloseAccount?.TEXT_ABOUT_TO_DELETE_ACCOUNT,
    TEXT_SELECT_ALL = English?.CloseAccount?.TEXT_SELECT_ALL,
    TEXT_CHECKBOX_INSTRUCTION = English?.CloseAccount?.TEXT_CHECKBOX_INSTRUCTION,
    TEXT_CHECKBOX_HEADER_1 = English?.CloseAccount?.TEXT_CHECKBOX_HEADER_1,
    TEXT_CHECKBOX_HEADER_2 = English?.CloseAccount?.TEXT_CHECKBOX_HEADER_2,
    TEXT_SUBHEADER_1 = English?.CloseAccount?.TEXT_SUBHEADER_1,
    TEXT_SUBHEADER_2 = English?.CloseAccount?.TEXT_SUBHEADER_2,
    TEXT_SUBHEADER_3 = English?.CloseAccount?.TEXT_SUBHEADER_3,
    TEXT_SUBHEADER_4 = English?.CloseAccount?.TEXT_SUBHEADER_4,
    TEXT_SUBHEADER_5 = English?.CloseAccount?.TEXT_SUBHEADER_5,
    TEXT_SUBHEADER_6 = English?.CloseAccount?.TEXT_SUBHEADER_6,
    TEXT_SUBHEADER_7 = English?.CloseAccount?.TEXT_SUBHEADER_7,
    TEXT_SUBHEADER_8 = English?.CloseAccount?.TEXT_SUBHEADER_8,
    TEXT_DELETE_MY_ACCOUNT = English?.CloseAccount?.TEXT_DELETE_MY_ACCOUNT
  } = multiLanguageData?.CloseAccount || {};

  const { firstBox, secondBox } = checkboxState;
  const error = !firstBox || !secondBox;

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prev) => ({ ...prev, [name]: checked }));
  };

  const handleAccountDeletion = async () => {
    try {
      setIsLoading(true);
      const response = await Getrequestcall(DEACTIVATE_USER_ACCOUNT, loginData?.accessToken);
      if (response?.data?.status === true && response?.data?.message === "OK") {
        persistor.purge();
        localStorage.removeItem("persist:root");
        window.location.reload();
      }
    } catch (err) {
      console.error("handleAccountDeletion-> Error When DEACTIVATE USERACCOUNT: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  const renderChecklist = (title, items, name, checked) => (
    <FormGroup sx={{ mt: 1 }}>
      <FormControlLabel
        control={<Checkbox checked={checked} name={name} onChange={handleCheckboxChange} />}
        label={title}
      />
      <Box component="ul" sx={{ mt: 0, pl: 4 }}>
        {items.map((text, i) => (
          <li style={{ paddingTop: 4 }} key={i}>
            {text}
          </li>
        ))}
      </Box>
      <FormLabel className="error-label">{TEXT_CHECKBOX_INSTRUCTION}</FormLabel>
    </FormGroup>
  );

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_CLOSE_ACCOUNT} />
      <Card className="main-content-card" sx={{ justifyContent: "space-between" }}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Box>
              <Typography variant="body1">
                {TEXT_ABOUT_TO_DELETE_ACCOUNT} <b>({loginData?.userInformation?.Email})</b>
              </Typography>

              <Typography variant="body1" sx={{ mt: 1 }}>
                {TEXT_SELECT_ALL}
              </Typography>

              <Box sx={{ ml: 3 }}>
                <FormControl required error={error} component="fieldset" variant="standard">
                  {renderChecklist(
                    TEXT_CHECKBOX_HEADER_1,
                    [TEXT_SUBHEADER_1, TEXT_SUBHEADER_2, TEXT_SUBHEADER_3],
                    "firstBox",
                    firstBox
                  )}
                  {renderChecklist(
                    TEXT_CHECKBOX_HEADER_2,
                    [
                      TEXT_SUBHEADER_4,
                      TEXT_SUBHEADER_5,
                      TEXT_SUBHEADER_6,
                      TEXT_SUBHEADER_7,
                      TEXT_SUBHEADER_8
                    ],
                    "secondBox",
                    secondBox
                  )}
                </FormControl>
              </Box>
            </Box>

            <Stack sx={{ display: "flex", alignItems: "center" }}>
              <Button
                color="secondary"
                variant="contained"
                size="large"
                disabled={error || isLoading}
                onClick={handleAccountDeletion}
                sx={{ p: 1 }}>
                {TEXT_DELETE_MY_ACCOUNT}
              </Button>
            </Stack>
          </>
        )}
      </Card>
    </Box>
  );
}
